export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4613.152fef8f.jpg";